import { Table } from "antd";
import { DataType } from "../../../models/interface/license.interface";
import { Columns } from "./Column";
import PaginationComponent from "./Pagination";

const App = ({ data, total }: { data: DataType[]; total: number }) => {
  return (
    <div className="border border-solid border-[#EBEEF2] rounded-lg">
      <Table<DataType>
        columns={Columns}
        dataSource={data}
        pagination={false}
        scroll={{ x: 1200 }}
        tableLayout="fixed"
        className="custom-table"
      />
      <PaginationComponent total={total} />
    </div>
  );
};

export default App;
